// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__VbPsl","load6":"style_load6__2zelE","round":"style_round__YgJOZ"};